import defaultSettings from '../settings.json';
export interface GlobalState {
  settings?: typeof defaultSettings;
  userInfo?: {
    id?: string;
    account?: string;
    nickname?: string;
    isSuper?: number;
    permissions: string[];
    remark?: string;
  };
  userLoading?: boolean;
  projectForbidTodoDescVisible?: boolean;
}

const initialState: GlobalState = {
  settings: defaultSettings,
  userInfo: {
    permissions: [],
  },
  projectForbidTodoDescVisible: false,
};

export default function store(state = initialState, action) {
  switch (action.type) {
    case 'update-settings': {
      const { settings } = action.payload;
      return {
        ...state,
        settings,
      };
    }
    case 'update-userInfo': {
      const { userInfo = initialState.userInfo, userLoading } = action.payload;
      return {
        ...state,
        userLoading,
        userInfo,
      };
    }
    case 'update-projectForbidTodoDescVisible': {
      const { projectForbidTodoDescVisible } = action.payload;
      return {
        ...state,
        projectForbidTodoDescVisible,
      };
    }
    default:
      return state;
  }
}
